import notificationCenterReducer from "./notificationCenterSlice";

export default notificationCenterReducer;
